/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Thu Jun 6 2019 3:16:54 PM
 *
 *******************************************************/
//flow
import React, { Component } from 'react';
import { connect } from 'react-redux';

import * as optionEmailAction from 'actions/dashboard/option-email-action';
import * as dashboardAction from 'actions/dashboard-actions';

import { Stack, RadioButton, ButtonGroup, Button, FormLayout } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { Field, reduxForm } from 'redux-form';
import { isEmail, isExceedLength } from 'src/helpers/form-validation-helper';
import { RenderTextField } from 'src/components/views/common/forms/render-textfield';

import history from 'src/routes/history';
import { routes } from 'src/routes';
import { showBeaconChat } from 'src/integrations/beacon';

type Props = {
  handleChangeState: () => void
};

type ComposedProps = Props & WithI18nProps;
const isExceedLengthValue = isExceedLength(50);
// DONE

const isEmailValue = isEmail();
class Option3 extends Component<ComposedProps> {
  render() {
    const { i18n, loading, handleSubmit, pristine } = this.props;
    return (
      <div>
        <Stack vertical>
          <RadioButton
            label={i18n.translate('AdminHTML.Installation.Feedback.option3_RadioButton_Label')}
            checked={true}
            id="3"
            name="options"
          />
          <div style={{ marginLeft: '1.75rem' }}>
            <FormLayout>
              <p>{i18n.translate('AdminHTML.Installation.Feedback.option3_Paragraph')}</p>

              <Field
                name="optEmail"
                label={i18n.translate('AdminHTML.Common.FieldLabel.signupEmail')}
                component={RenderTextField}
                placeholder={i18n.translate('AdminHTML.Common.Placeholder.email')}
                validate={[isEmailValue, isExceedLengthValue]}
              />
              <p style={{ marginTop: '-1.25rem', color: 'gray', fontStyle: 'bold' }}>
                {i18n.translate('AdminHTML.Installation.Common.subEmail')}
              </p>
            </FormLayout>
          </div>
          <div style={{ marginLeft: 'auto' }}>
            <ButtonGroup>
              <Button onClick={this.back}>{i18n.translate('AdminHTML.Common.Action.back')}</Button>
              <Button
                primary
                loading={loading && !pristine}
                onClick={handleSubmit(this.toThemeSetup.bind(this))}>
                {i18n.translate('AdminHTML.Installation.Feedback.option3_ButtonChildren')}
              </Button>
            </ButtonGroup>
          </div>
        </Stack>

        <span className="clear" />
      </div>
    );
  }

  // Handle back action
  back = () => {
    const { handleChangeState } = this.props;

    handleChangeState(0);
  };

  //Handle go to theme setup action
  toThemeSetup = async data => {
    const { addOptionEmail, dismissDashboardBlock } = this.props;
    if (data.optEmail) {
      const result = await addOptionEmail(data);
      if (result.type === 'ADD_OPTION_EMAIL_SUCCESS') {
        dismissDashboardBlock('optionInEmail');
      }
    }
    history.push(routes.themeSetup.view());
    showBeaconChat();
  };
}
const mapStateToProps = (state, props) => ({
  loading: state.optionEmail.loading,
  success: state.optionEmail.success,
  error: state.optionEmail.error
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  addOptionEmail: (body: Object) => dispatch(optionEmailAction.addOptionEmail(body, ownProps.i18n)),
  dismissDashboardBlock: (blockName: string) =>
    dispatch(dashboardAction.processDismissBlock(blockName, ownProps.i18n))
});
const Option3Form = reduxForm({
  form: 'Option1', // a unique identifier for this form
  enableReinitialize: true
})(Option3);
export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(Option3Form));
